import { useSyncExternalStore } from "react";
import { getAppearance, setAppearance, subscribeAppearance, type Appearance } from "../appearance";

const OPTIONS: { value: Appearance; label: string }[] = [
  { value: "standard", label: "Standard" },
  { value: "cute", label: "Cute" },
  { value: "dream", label: "Dreamland" },
  { value: "forest", label: "Forest" },
  { value: "sunset", label: "Sunset" },
  { value: "ember", label: "Ember" },
];

type Props = {
  id?: string;
  /** Stacked label + full-width select (e.g. mobile drawer footer). */
  layout?: "inline" | "stacked";
};

export function AppearanceSelect({ id = "appearance-select", layout = "inline" }: Props) {
  const appearance = useSyncExternalStore(subscribeAppearance, getAppearance, () => "standard" as Appearance);

  return (
    <div className={`appearance-select-wrap${layout === "stacked" ? " appearance-select-wrap--stacked" : ""}`}>
      <label htmlFor={id} className="appearance-select-label">
        <span className="muted">Appearance</span>
        <select id={id} value={appearance} onChange={(e) => setAppearance(e.currentTarget.value as Appearance)}>
          {OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
